export type PrimitiveVariableType = 'PRIMITIVE';
export const PRIMITIVE_VARIABLE_TYPE = 'PRIMITIVE';
